import { j as jsxRuntimeExports } from "./auth-service-tools177.js";
import { useRef } from "react";
import { createEventHandler } from "./auth-service-tools186.js";
import { useProps } from "./auth-service-tools225.js";
import { factory } from "./auth-service-tools248.js";
import { Popover } from "./auth-service-tools264.js";
import { useMenuContext } from "./auth-service-tools376.js";
import classes from "./auth-service-tools382.js";
import { useMergedRef } from "./auth-service-tools278.js";
const defaultProps = {};
const MenuDropdown = factory((props, ref) => {
  const {
    classNames,
    className,
    style,
    styles,
    vars,
    onMouseEnter,
    onMouseLeave,
    onKeyDown,
    children,
    ...others
  } = useProps("MenuDropdown", defaultProps, props);
  const wrapperRef = useRef(null);
  const ctx = useMenuContext();
  const handleKeyDown = createEventHandler(onKeyDown, event => {
    var _a, _b;

    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      event.preventDefault();
      (_b = (_a = wrapperRef.current) == null ? void 0 : _a.querySelectorAll("[data-menu-item]:not(:disabled)")[0]) == null ? void 0 : _b.focus();
    }
  });
  const handleMouseEnter = createEventHandler(onMouseEnter, () => (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.openDropdown());
  const handleMouseLeave = createEventHandler(onMouseLeave, () => (ctx.trigger === "hover" || ctx.trigger === "click-hover") && ctx.closeDropdown());
  return /* @__PURE__ */jsxRuntimeExports.jsxs(Popover.Dropdown, { ...others,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    role: "menu",
    "aria-orientation": "vertical",
    ref: useMergedRef(ref, wrapperRef),
    ...ctx.getStyles("dropdown", {
      className,
      style,
      styles,
      classNames,
      withStaticClass: false
    }),
    tabIndex: -1,
    "data-menu-dropdown": true,
    onKeyDown: handleKeyDown,
    children: [/* @__PURE__ */jsxRuntimeExports.jsx("div", {
      tabIndex: -1,
      "data-autofocus": true,
      "data-mantine-stop-propagation": true,
      style: {
        outline: 0
      }
    }), children]
  });
});
MenuDropdown.classes = classes;
MenuDropdown.displayName = "@mantine/core/MenuDropdown";
export { MenuDropdown };